enum AmplitudeEvent {
  ButtonClick = "button_click",
  PageView = "page_view",
}

export default AmplitudeEvent;
